import Commands from './commands';

class DivBy extends Commands {
    constructor(registry) {
        super("divBy", registry);
    }

    async execute(node, emitter, options) {
        const key = await emitter(node.params[0], options);
        const dividedBy = parseFloat(await emitter(node.params[1], options));
        const value = parseFloat(this.registry.get(key));
        this.registry.set(key, value / dividedBy);
        return value / dividedBy;
    }
}

export default DivBy;
